import { render, staticRenderFns } from "./program-filter.vue?vue&type=template&id=9c827be2&scoped=true&"
import script from "./program-filter.vue?vue&type=script&lang=ts&"
export * from "./program-filter.vue?vue&type=script&lang=ts&"
import style0 from "./program-filter.vue?vue&type=style&index=0&id=9c827be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c827be2",
  null
  
)

export default component.exports